import Colors from 'constants/Colors';

export default {
  sftpWarningStyle: {
    padding: 8,
    justifyContent: 'flex-start',
    color: Colors.yellowHotelNoIntegratedText,
    backgroundColor: Colors.yellowHotelNoIntegratedBg,
    borderColor: Colors.yellowHotelNoIntegratedText,
    fontSize: 14,
    margin: 0,
    width: '100%',
  },
  apiGoodStyle: {
    padding: 8,
    justifyContent: 'flex-start',
    color: Colors.greenHotelIntegratedText,
    backgroundColor: Colors.greenHotelIntegratedBg,
    borderColor: Colors.greenHotelIntegratedText,
    fontSize: 14,
    margin: 0,
    width: '100%',
  },
  info: {
    padding: 8,
    justifyContent: 'flex-start',
    color: Colors.blueIntense,
    fontSize: 14,
    margin: 0,
    width: '100%',
  },
  infoTitle: {
    fontWeight: 'bold',
  },
};
